import { useState } from 'react';
import PropTypes from 'prop-types';

import EyeOpenImg from '../../../../images/global/eye-open.svg';
import EyeHideImg from '../../../../images/global/eye-hide.svg';

const inputStyle = {
  fontFamily: 'Source Sans Pro',
  width: '200px',
  height: '40px',
  border: 'none',
  borderRadius: '4px',
  backgroundColor: 'rgba(240, 242, 245, 0.79)',
  outline: 'none',
  paddingLeft: '10px',
  paddingRight: '10px',
  color: '#0f2045',
};

const PasswordInput = ({
  label = undefined,
  value = '',
  onChange = () => {},
  onBlur = () => {},
  placeholder = undefined,
  error = undefined,
  errorText = undefined,
  afterText = undefined,
}) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className="password-input">
      {label && <p className="onboarding-label">{label}</p>}
      <div className="input-field">
        <input
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          style={inputStyle}
          type={visible ? 'text' : 'password'}
        />
        <div
          className="show-icon"
          onClick={() => setVisible(prev => !prev)}
          aria-hidden="true"
        >
          {visible ? <EyeHideImg /> : <EyeOpenImg />}
        </div>
      </div>
      {afterText && <span>{afterText}</span>}
      {(error || errorText) && (
        <p className="onboarding-error">{error || errorText}</p>
      )}
    </div>
  );
};

PasswordInput.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  error: PropTypes.string,
  errorText: PropTypes.string,
  afterText: PropTypes.string,
};

export default PasswordInput;
